<!--
 * @Description: 资源自定义分类 收藏
 * @Author: PF
 * @Date: 2023-07-07 09:57:07
 * @LastEditors: PF
 * @LastEditTime: 2023-07-07 10:17:31
-->
<template>
  <div>
    <el-dialog class="w500 h320" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">收藏资源</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="90px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="收藏标注" prop="scbz" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.scbz" :rows="5" type="textarea" resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow } from '@/api/common.js'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/ziyuan/ziyuanshoucang',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.zyid = props.row.id
    }
  },
  { deep: true, immediate: true }
)
</script>
